const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'm-scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'm-scroll-trigger--offscreen';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);

        // Stagger children if data-cascade is present
        if (elementTarget.hasAttribute('data-cascade')) {
          const children = elementTarget.querySelectorAll('.m-scroll-trigger, [data-cascade-item]');
          children.forEach((child, i) => {
            child.style.transitionDelay = `${i * 0.15}s`;
            child.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
          });
        }
      }
      observer.unobserve(elementTarget);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document) {
  // Global sections and key blocks
  const selectors = 'section, .m-section, .m-product-card, .m-collection-card, .m-image-card';
  rootEl.querySelectorAll(selectors).forEach(el => {
    if (!el.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) {
      el.classList.add(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
      el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    }
  });

  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -15% 0px',
    threshold: 0.05
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

window.addEventListener('load', () => {
  setTimeout(initializeScrollAnimationTrigger, 100);
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document));
}